import { DeleteRounded, EditRounded } from '@mui/icons-material';
import { Grid, IconButton, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Screen from '../../components/fragments/Screen';
import { removeFromLocalList } from '../../store/slices/localSlice';

export default function NotepadRouteScreen() {
    const {
        state: { id, note, title },
    } = useLocation();

    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return (
        <Screen
            authPass
            title="Note"
            controls={
                <>
                    <IconButton
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        sx={{ mr: 1 }}
                        onClick={() =>
                            navigate('/bible-tools/notepad-add', {
                                state: { id, note, title },
                            })
                        }
                        color={
                            theme.palette.mode === 'light'
                                ? 'primary'
                                : 'inherit'
                        }
                    >
                        <EditRounded />
                    </IconButton>
                    <IconButton
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={() => {
                            dispatch(
                                removeFromLocalList({ list: 'notes', id })
                            );
                            navigate(-1);
                        }}
                        color={
                            theme.palette.mode === 'light'
                                ? 'primary'
                                : 'inherit'
                        }
                    >
                        <DeleteRounded />
                    </IconButton>
                </>
            }
        >
            <Grid item xs={12}>
                <Typography className="fw-bold">{title}</Typography>
                <Typography>{note}</Typography>
            </Grid>
        </Screen>
    );
}
